import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {GameInfo} from "../../../games/game-info";
import {GameFilterDefinitionBase} from "../game-filter-definition-base";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

export class GameThemeFilterDefinition extends GameFilterDefinitionBase {
    constructor(public readonly id: string,
                protected readonly services: IServiceFactoryExtended,
                public themeName: string,
                public themeIds: number[],
                private _text?: string ) {
        super(services);
    }

    get text(): string {
        if(this._text) {
            return this._text;
        }
        return this.themeName;
    }

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        for(let themeId of gameInfo.themeIds) {
            if(this.themeIds.includes(themeId)) {
                return ApplyGameFilterResult.IncludeGame;
            }
        }
        return ApplyGameFilterResult.ExcludeGame;
    }
}